import { Paper } from '@mui/material';
import { get as lodashGet } from 'lodash';
import React from 'react';
import { SectionMask } from 'src/app/common/components/section-mask/section-mask.component';
import { useAttachment } from './attachment.hook';
import { useStyles } from './attachment.style';
import { AttachmentUploaderComponent } from '../../attachment-uploader/attachment-uploader.component';
import { AttachmentProps } from './attachment.hook';

export const Attachment: React.FC<AttachmentProps> = ({
  sectionKey,
  campaignTypeStructureData,
  formDispatch,
  formState,
  errorState,
  disabledEdit,
  disabled,
  validationHandler,
  isCampaignFilesUpdated,
  onSaveCampaign,
  campaignObjId,
  // onStepChange,
  isProofUpdated,
  isAttachmentUpdated,
  onSaveAttachment,
}) => {
  const { classes } = useStyles();

  const { attachmentData, uploadAttachment, removeFile, viewFile, Translation } = useAttachment({
    sectionKey,
    campaignTypeStructureData,
    formDispatch,
    formState,
    errorState,
    disabledEdit,
    disabled,
    validationHandler,
    isCampaignFilesUpdated,
    onSaveCampaign,
    campaignObjId,
    isProofUpdated,
    isAttachmentUpdated,
    onSaveAttachment,
  });

  if (lodashGet(attachmentData, 'sectionFields', []).length < 1) {
    return <span className={classes.p_10}>{Translation('agencyCampaign.create.noAttachmentRequired')}</span>;
  }

  return (
    <>
      {attachmentData.sectionFields.map((fieldItem: any, index) => {
        return (
          <SectionMask key={index} showMask={!campaignObjId} text={Translation('agencyCampaign.detail.screen.mask')}>
            <Paper elevation={3} sx={{ marginBottom: '24px' }}>
              <AttachmentUploaderComponent
                fieldItem={fieldItem}
                sectionKey={sectionKey}
                formState={formState}
                errorState={errorState}
                disabled={disabled}
                disabledEdit={disabledEdit}
                onUpload={uploadAttachment}
                removeFile={removeFile}
                viewFile={viewFile}
                onSave={onSaveAttachment}
                isCampaignFilesUpdated={isCampaignFilesUpdated}
              />
            </Paper>
          </SectionMask>
        );
      })}
    </>
  );
};
